module.exports = __webpack_public_path__ + "img/1.b48414ae.jpg";